import React, { useState, useCallback, useEffect } from 'react'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { useOrgaoService } from 'hooks/useOrgaoService'
import { TextField, Checkbox } from '@material-ui/core'

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectOrgao = (props) => {
  const orgaoService = useOrgaoService()
  const [orgaos, setOrgaos] = useState([])
  const { orgaosExternos, setOrgaosExternos, setProcessando, label } = props
  const [listaOpcoesOrgaosFiltros, setListaOpcoesOrgaosFiltrados] = useState([])
  const [inputOrgao, setInputOrgao] = useState(null)

  const fetchOrgaos = useCallback(async () => {
    const response = await orgaoService.listarOrgaosAsyncRequisicoes(setProcessando)
    setOrgaos(response)
  }, [])

  const handleChangeInputOrgao = useCallback(
    (value) => {
      setInputOrgao(value)
      if (orgaos) {
        if (value?.length > 2) {
          setListaOpcoesOrgaosFiltrados((prevState) => orgaos.filter((orgao) => orgao.nome?.toUpperCase().includes(value?.toUpperCase()) || orgao.sigla?.toUpperCase().includes(value?.toUpperCase())))
        } else {
          setListaOpcoesOrgaosFiltrados([])
        }
      }
    },
    [orgaos]
  )

  useEffect(() => {
    fetchOrgaos()
  }, [fetchOrgaos])

  return (
    <AutocompleteNative
      value={orgaosExternos}
      multiple
      name="orgaos"
      noOptionsText="Sem informações"
      options={listaOpcoesOrgaosFiltros || []}
      onChange={(event, newValue) => {
        setOrgaosExternos(newValue)
      }}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => `${option.nome.toUpperCase()} ${option.sigla ? ` - ${option.nome.toUpperCase()}` : ''}`}
      renderOption={(option, { selected }) => (
        <>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{
              marginRight: 8,
            }}
            checked={selected}
          />
          {option.nome.toUpperCase()} {option.nome ? ` - ${option.sigla.toUpperCase()}` : ''}
        </>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          InputLabelProps={{
            shrink: true,
          }}
          value={inputOrgao}
          onChange={(e) => handleChangeInputOrgao(e.target.value)}
        />
      )}
    />
  )
}
